import { useState, type FormEvent } from "react";
import { useSessao } from "../estado/sessao";
import { FalhaApi } from "../api";

export function Login() {
  const { entrar } = useSessao();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function aoEnviar(evento: FormEvent) {
    evento.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(email, senha);
    } catch (e) {
      // A mensagem vem do servidor (deliberadamente genérica para não revelar se o e-mail existe
      // ou se a senha está errada); só o 429 do rate limit ganha um texto mais explicativo.
      setErro(
        e instanceof FalhaApi
          ? e.message
          : "Não foi possível conectar ao servidor. Verifique sua internet."
      );
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="tela-login">
      <form className="cartao cartao-login" onSubmit={aoEnviar}>
        <h1 className="marca">
          Vistor<span>IA</span>
        </h1>
        <p className="subtitulo">Checklist de vistoria predial</p>

        {erro && (
          <div className="alerta alerta-erro" role="alert">
            {erro}
          </div>
        )}

        <label htmlFor="email">E-mail</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />

        <label htmlFor="senha">Senha</label>
        <input
          id="senha"
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          autoComplete="current-password"
          required
        />

        <button className="botao botao-primario" type="submit" disabled={enviando}>
          {enviando ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}
